<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [header]="'Libro mayor · ' + folio"
  styleClass="lease-ledger-dialog"
  [style]="{ width: '1040px', maxWidth: '96vw' }"
  (onHide)="cerrar()"
>
  <div class="lld-body">
    <p class="lld-error" *ngIf="error">{{ error }}</p>

    <!--
      La MISMA franja que pinta la pestaña de Exigibilidad. Recibe datos planos, así que se reusa tal
      cual: copiarla habría creado dos versiones que dicen lo mismo y se separan a la primera
      corrección.

      ! La condición exige `cargando || ledger` y NO solo `!error`. El contenido del `p-dialog` se
      ! instancia aunque esté cerrado, y la franja lee `totals.overdueAmount` sin guarda en cuanto
      ! `loading` es falso: sin esto, entrar a Cartera reventaba la consola ocho veces antes de que
      ! nadie abriera nada.
    -->
    <app-ledger-strip
      *ngIf="!error && (cargando || ledger)"
      [totals]="ledger?.totals!"
      [quality]="ledger?.quality || null"
      [periods]="ledger?.periods || []"
      [unapplied]="ledger?.unapplied || []"
      [moraPaused]="moraPausada"
      [loading]="cargando"
      [readOnly]="true"
    ></app-ledger-strip>

    <ng-container *ngIf="!cargando && !error && ledger">
      <!-- Solo lectura, dicho. Contabilidad no tiene el permiso de aplicar ni anular. -->
      <p class="lld-note">Vista de <b>solo lectura</b>. Aplicar, anular o condonar se hace desde el centro de pagos.</p>

      <h4 class="lld-h4">
        Letras con saldo
        <span class="lld-count">{{ periodosConSaldo.length }}</span>
      </h4>

      <p class="lld-empty" *ngIf="!periodosConSaldo.length">Este arrendamiento no tiene letras con saldo: está al corriente.</p>

      <div class="lld-scroll" *ngIf="periodosConSaldo.length">
        <table class="lld-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Vence</th>
              <th class="lld-num">Renta</th>
              <th class="lld-num">Aplicado</th>
              <th class="lld-num">Falta</th>
              <th class="lld-num">Mora</th>
              <th>Factura</th>
              <th>Estatus</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let p of periodosConSaldo">
              <td>{{ p.n }}</td>
              <!-- Las fechas de letra son día de calendario en UTC: pintarlas en local las corre un día. -->
              <td>{{ p.date | date: 'dd/MM/yy' : 'UTC' }}</td>
              <td class="lld-num">{{ p.nominal?.rent | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</td>
              <td class="lld-num">{{ p.applied?.total | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</td>
              <td class="lld-num lld-pend">{{ p.pending | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</td>
              <td class="lld-num">
                {{ p.mora?.balance | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}
                <!-- Con el interruptor apagado la mora se conserva pero NO es exigible: hay que decirlo. -->
                <small class="lld-paused" *ngIf="p.mora?.paused">en pausa</small>
              </td>
              <td class="lld-mono">{{ p.invoice?.active?.folioFiscal || '—' }}</td>
              <td><p-tag [severity]="severidad(p)" [value]="etiqueta(p)"></p-tag></td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>
  </div>

  <ng-template pTemplate="footer">
    <button pButton type="button" label="Cerrar" class="p-button-text" (click)="cerrar()"></button>
  </ng-template>
</p-dialog>
